import { attendancesModel } from "../../appContainer/_utils/models";
import { takeEvery, select, call } from 'redux-saga/effects';
import delay from 'redux-saga';
import * as firebase from 'firebase';
import 'firebase/firestore';
import * as TYPES from '../Redux.actionTypes';
import _ from 'lodash';
import moment from 'moment'
import uuid from 'uuid/v4';
import { selectedDevotionalGroupSelector } from '../Redux.selectors';

// const attendancesModel = {
//   attended: false,
//   attendee: {}, // reference to devotee
//   createdBy: {}, // reference to logged in user
//   createdOn: {}, // timestamp
//   delivery: '', // online|inPerson|
//   event: {}, // event reference
//   eventAgreement: {
//     description: '',
//     hasAgreement: false,
//     onGoingAgreement: {}, // reference to agreement
//   },
//   group: {},
//   id: '', // uuidv4
//   location: {},
//   notes: '',
//   participation: '', // full|partial
// };

function* setAttendance({ value }) {
  const { attended, eventId, devoteeId, attendance } = value;
  const timeStamp = moment().toDate().toISOString();

  // If the value of attended is unknown, then delete the attendance record
  if (!attended && attendance) {
    yield firebase.firestore().collection('attendances').doc(attendance.id).delete();
  }

  // If attendance was recorded and there's an existing attendance record, update it
  if (attended && attendance) {
    attended.modifiedOn = timeStamp;
    const data = _.merge({ ...attendance }, attended);
    // TODO: see if there's a better way to do this since the merge doesn't work for deep updates
    data.eventAgreement = attended.eventAgreement;
    yield firebase.firestore().collection('attendances').doc(attendance.id).update(data);
    yield call(delay, 0);
  }

  // If attendance was recorded and there's no existing attendance record, create one
  if (attended && !attendance) {
    const selectedDevotionalGroup = yield select(selectedDevotionalGroupSelector);
    const id = uuid();
    attended.attendee = firebase.firestore().collection('devotees').doc(devoteeId);
    attended.event = firebase.firestore().collection('events').doc(eventId);
    attended.group = firebase.firestore().collection('devotionalGroups')
      .doc(selectedDevotionalGroup.id);
    attended.createdOn = timeStamp;
    attended.id = id;
    const data = _.merge({ ...attendancesModel }, attended);
    yield firebase.firestore().collection('attendances').doc(id).set(data);
  }
}

function* watchSetAttendance() {
  yield takeEvery(TYPES.SET_ATTENDANCE, setAttendance);
}

export {
  watchSetAttendance,
  setAttendance,
}
